export default function notInBusiness({ next, to, router, store }) {
  const business = store.getters.authUser.business;

  if (business) {
    return router.replace("/dashboard");
  }

  next(); // make sure to always call next()!
}
